// extracted by mini-css-extract-plugin
export var productImage = "_rg-1";
export var viewLink = "_rg-2";
export var wishlistItem = "_rg-0";